import { css } from 'styled-components'

export default css`
  color: #404040;
  font-size: 16px;
  margin-bottom: 0px;
  text-decoration: none;
  &:hover {
    color: #404040;
    text-decoration: none;
  }
  &:focus,
  &:active {
    color: #555;
    font-weight: bold;
    text-decoration: none;
  }
`
